import { addDisposableListener, Emitter } from '../../../events';
import { CompositeDisposable } from '../../../lifecycle';
import { toggleClass } from '../../../dom';
import { applyTabGroupAccent, } from '../../tabGroupAccent';
export class TabGroupChip extends CompositeDisposable {
    get element() {
        return this._element;
    }
    constructor(_palette) {
        super();
        this._palette = _palette;
        this._onClick = new Emitter();
        this.onClick = this._onClick.event;
        this._onContextMenu = new Emitter();
        this.onContextMenu = this._onContextMenu.event;
        this._onDragStart = new Emitter();
        this.onDragStart = this._onDragStart.event;
        this._element = document.createElement('div');
        this._element.className = 'dv-tab-group-chip';
        this._element.tabIndex = 0;
        this._element.draggable = true;
        this._label = document.createElement('span');
        this._label.className = 'dv-tab-group-chip-label';
        this._element.appendChild(this._label);
        this.addDisposables(this._onClick, this._onContextMenu, this._onDragStart, addDisposableListener(this._element, 'click', (event) => {
            this._onClick.fire(event);
        }), addDisposableListener(this._element, 'contextmenu', (event) => {
            this._onContextMenu.fire(event);
        }), addDisposableListener(this._element, 'dragstart', (event) => {
            this._onDragStart.fire(event);
        }));
    }
    init(params) {
        this._tabGroup = params.tabGroup;
        this.updateColor(params.tabGroup.color);
        this.updateLabel(params.tabGroup.label);
        this.updateCollapsed(params.tabGroup.collapsed);
        this.addDisposables(params.tabGroup.onDidChange(() => {
            if (this._tabGroup) {
                this.updateColor(this._tabGroup.color);
                this.updateLabel(this._tabGroup.label);
            }
        }), params.tabGroup.onDidCollapseChange((collapsed) => {
            this.updateCollapsed(collapsed);
        }), this._onClick.event(() => {
            var _a;
            (_a = this._tabGroup) === null || _a === void 0 ? void 0 : _a.toggle();
        }));
    }
    update(params) {
        this._tabGroup = params.tabGroup;
        this.updateColor(params.tabGroup.color);
        this.updateLabel(params.tabGroup.label);
        this.updateCollapsed(params.tabGroup.collapsed);
    }
    updateColor(color) {
        var _a;
        applyTabGroupAccent(this._element, color, this._palette);
        toggleClass(this._element, 'dv-tab-group-chip--accent-off', ((_a = this._palette) === null || _a === void 0 ? void 0 : _a.enabled) === false);
    }
    updateLabel(label) {
        this._label.textContent = label;
        toggleClass(this._label, 'dv-tab-group-chip-label--empty', !label);
    }
    updateCollapsed(collapsed) {
        toggleClass(this._element, 'dv-tab-group-chip--collapsed', collapsed);
    }
}
